import { z } from "zod/v4";
import { tournamentHitSchema } from "../../schemas/bis";
import { fetchApi } from "../client/internal";

export const tournaments = {
	search: (q: string, limit?: number) => {
		const query = new URLSearchParams({ q });
		if (limit) query.set("limit", String(limit));
		return fetchApi(`/tournaments?${query}`, z.array(tournamentHitSchema));
	},
};
